export const BASE_CRM_URL = process.env.REACT_APP_BASE_CRM_URL;
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
export const site_identifier = 'client';
export const hit_type_pageview = 'pageview';
export const hit_type_event = 'event';

let contact_us = '<a href="/contactus">Contact Us</a>';
export const defaultProcessingError = 'An unexpected error occurred while processing the data.';
export const errorCodes = {
  'EmailAlreadyInUse': 'The email address you\'ve entered is associated with another account. To change your account to this email address, please ' + contact_us + ' for assistance.',
  'DefaultSaveError': 'An unexpected error occurred while saving the data.',
};


// WEBPACK FOOTER //
// ./src/constants/index.js